import React, { useState } from "react";
import {
    Col,
    Row,
    Container,
    Nav,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap";
import classnames from "classnames";

//Process Images Import
import processImage1 from "../../../assets/images/process-01.png";
import processImage2 from "../../../assets/images/process-02.png";
import processImage3 from "../../../assets/images/process-03.png";

const HowItWorks = ({ type }) => {
    const [activeTab, setActiveTab] = useState("1");

    const tabChange = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    return (
        <React.Fragment>
            <section className="section" style={{ marginBottom: '-50px' }}>
                <Container>
                    <Row className={`align-items-center ${type === "client" ? "g-5" : ""}`}>
                        <Col lg={6} className={type === "client" ? "order-lg-2" : "order-lg-1"}>
                            <div className="section-title me-5">
                                <h3 className="title">Our Hiring Process</h3>
                                <p className="text-muted">
                                    Here’s how we bring you top-tier candidates while saving you time and minimizing risk:
                                </p>
                                <Nav className="process-menu  flex-column nav-pills">
                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "1" })}
                                        onClick={() => {
                                            tabChange("1");
                                        }}
                                        type="button"
                                    >
                                        <div className="d-flex">
                                            <div className="number flex-shrink-0">1</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Discovery &amp; Needs Analysis</h5>
                                                <p className="text-muted">
                                                    We begin with a deep dive into your business—your goals, values, operations, and the unique
                                                    requirements of the role. We don’t just ask about the job description—we explore the big picture
                                                    to ensure we understand what success looks like in your organization.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>

                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "2" })}
                                        onClick={() => {
                                            tabChange("2");
                                        }}
                                        type="button"
                                    >
                                        <div className="d-flex">
                                            <div className="number flex-shrink-0">2</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Talent Strategy Development</h5>
                                                <p className="text-muted mb-0">
                                                    We create a customized recruitment plan tailored to your needs. Whether it’s a retained search,
                                                    contingency placement, or a confidential executive search, we deploy the right tools, methods,
                                                    and outreach strategies to match your hiring goals.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>

                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "3" })}
                                        onClick={() => {
                                            tabChange("3");
                                        }}
                                        type="button"
                                    >
                                        <div className=" d-flex">
                                            <div className="number flex-shrink-0">3</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Sourcing &amp; Screening</h5>
                                                <p className="text-muted mb-0">
                                                    Using our extensive database, industry connections, and technology-driven sourcing tools,
                                                    we identify and engage high-potential candidates. Every candidate is rigorously screened not just
                                                    for qualifications—but also for attitude, cultural fit, and alignment with your company’s long-
                                                    term vision.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "4" })}
                                        onClick={() => {
                                            tabChange("4");
                                        }}
                                        type="button"
                                    >
                                        <div className=" d-flex">
                                            <div className="number flex-shrink-0">4</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Candidate Presentation</h5>
                                                <p className="text-muted mb-0">
                                                    We don’t flood your inbox with resumes. We provide a carefully curated shortlist of qualified,
                                                    high-potential candidates—with detailed insights into why each person is a strong match.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "5" })}
                                        onClick={() => {
                                            tabChange("5");
                                        }}
                                        type="button"
                                    >
                                        <div className=" d-flex">
                                            <div className="number flex-shrink-0">5</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Interview Coordination &amp; Support</h5>
                                                <p className="text-muted mb-0">
                                                    We facilitate the process —from scheduling interviews to preparing
                                                    candidates—while keeping communication seamless and professional on both sides.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "6" })}
                                        onClick={() => {
                                            tabChange("6");
                                        }}
                                        type="button"
                                    >
                                        <div className=" d-flex">
                                            <div className="number flex-shrink-0">6</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Offer Management &amp; Hiring</h5>
                                                <p className="text-muted mb-0">
                                                    When you’re ready to make an offer, we act as an intermediary to help you secure the talent you need. We
                                                    serve as a bridge to ensure clarity, alignment, and satisfaction for both parties.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink
                                        to="#"
                                        className={classnames({ active: activeTab === "7" })}
                                        onClick={() => {
                                            tabChange("7");
                                        }}
                                        type="button"
                                    >
                                        <div className=" d-flex">
                                            <div className="number flex-shrink-0">7</div>
                                            <div className="flex-grow-1 text-start ms-3">
                                                <h5 className="fs-18">Post-Hire Follow-Up</h5>
                                                <p className="text-muted mb-0">
                                                    We stay connected after the hire to ensure a smooth onboarding process and long-term
                                                    satisfaction—for both you and your new team member.
                                                </p>
                                            </div>
                                        </div>
                                    </NavLink>
                                </Nav>
                            </div>
                        </Col>
                        <Col lg={6} className={type === "client" ? "order-lg-1" : "order-lg-2"}>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1">
                                    <img src={processImage1} alt="" className="img-fluid" draggable={false} />
                                </TabPane>
                                <TabPane tabId="2">
                                    <img src={processImage2} alt="" className="img-fluid" draggable={false} />
                                </TabPane>
                                <TabPane tabId="3">
                                    <img src={processImage3} alt="" className="img-fluid" draggable={false} />
                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default HowItWorks;
